import { Alert, AlertTitle, Grid, Typography } from '@mui/material';
import { DocumentData } from 'firebase/firestore';
import React, { useEffect, useState } from 'react';

import { getNotifications } from 'external/firebase/firestore/collections/notifications';
import useAuth from 'hooks/useAuth';

import useLocales from 'hooks/useLocales';

interface NotificationsProps {}

const Notifications: React.FunctionComponent<NotificationsProps> = () => {
    const { profile } = useAuth();
    const { translate } = useLocales();

    const [notifications, setNotifications] = useState<DocumentData>([]);
    const [error, setError] = useState<string | undefined>();
    const [isLoading, setIsLoading] = useState(true);

    const fetchNotifications = async (email: string, groups: string[], role: string) => {
        const resNotifications = await getNotifications(email, groups, role);
        if ('ok' in resNotifications) {
            setError(translate(resNotifications.code));
            setIsLoading(false);
            return;
        }
        setNotifications(resNotifications);
        setError(undefined);
        setIsLoading(false);
    };

    useEffect(() => {
        if (profile?.email && profile?.role) {
            fetchNotifications(profile.email, profile?.groups || [], profile.role);
        }
    }, [profile]);

    const handleAlertClose = (id: string) => {
        setNotifications(notifications.filter(notification => notification.id !== id));
    };

    return (
        <>
            {!isLoading && notifications.length > 0 && (
                <Grid container spacing={3} justifyContent='center' mb={3}>
                    {notifications.map(notification => (
                        <Grid item xs={12} md={10} key={notification.id}>
                            <Alert
                                variant='outlined'
                                severity={notification.severity || 'info'}
                                onClose={() => handleAlertClose(notification.id)}
                            >
                                <AlertTitle>{notification.message.title}</AlertTitle>
                                <div dangerouslySetInnerHTML={{ __html: notification.message.body }} />
                            </Alert>
                        </Grid>
                    ))}
                </Grid>
            )}
        </>
    );
};

export default Notifications;
